// extracted by mini-css-extract-plugin
export default {"container":"_26B66","small":"YxldA","triangle":"_1eAC0","top":"_1eQMV"};